window.addEventListener('DOMContentLoaded', (event) => {
    const text_size = document.getElementById('text_size');
    if(text_size) {
        const article = document.getElementById("article");
        const text_size_minus = document.querySelector("#text_size .minus");
        const text_size_plus = document.querySelector("#text_size .plus");

        let text_size_px = 18;

        text_size_minus.addEventListener("click", function () {
            text_size_px -= 1;
            text_size_update();
        });

        text_size_plus.addEventListener("click", function () {
            text_size_px += 1;
            text_size_update();
        });

        function text_size_update() {
            text_size_minus.disabled = false;
            text_size_plus.disabled = false;
            if (text_size_px <= 14) {
                text_size_minus.disabled = true;
            }
            if (text_size_px >= 24) {
                text_size_plus.disabled = true;
            }

            if(text_size_px >= 14 && text_size_px <= 24) {
                article.style.fontSize = text_size_px + "px";
            }
        }

        text_size_update();
    }
});